export const bulkUploadDocumentTypes = [
  {
    id: 1,
    name: 'Upload Users',
  }, {
    id: 2,
    name: 'Upload Groups',
  },
];
